import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'Cesar Castro';
const SITE_URL = 'https://cesarcastro.com.br';
const DEFAULT_IMAGE = `${SITE_URL}/logo512.png`;

interface SeoProps {
    title: string;
    description: string;
    path: string;
    image?: string;
    type?: 'website' | 'article';
    jsonLd?: object;
    noIndex?: boolean;
}

const Seo = ({ title, description, path, image = DEFAULT_IMAGE, type = 'website', jsonLd, noIndex = false }: SeoProps) => {
    const url = `${SITE_URL}${path}`;
    const fullTitle = path === '/' ? title : `${title} | ${SITE_NAME}`;

    return (
        <Helmet>
            <title>{fullTitle}</title>
            <meta name="description" content={description} />
            <link rel="canonical" href={url} />
            {noIndex && <meta name="robots" content="noindex, follow" />}

            <meta property="og:type" content={type} />
            <meta property="og:site_name" content={SITE_NAME} />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={description} />
            <meta property="og:url" content={url} />
            <meta property="og:image" content={image} />

            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={image} />

            {jsonLd && (
                <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
            )}
        </Helmet>
    );
};

export default Seo;
